export type AudioItemId = string;
// Special audio item id's
export const AudioItemListenerId: AudioItemId = 'ListenerItem';
export const AudioItemAmbisonicId: AudioItemId = 'AmbisonicItem';

export type AudioItemPosition = { xn: number, yn: number, rotation?: number };

/**
 * Representation of a audio item that has a icon and a position in relative space
 */
export interface AudioItem {
    id: AudioItemId;
    audioUrl: string;
    enabled: boolean;
    position: AudioItemPosition;
    blobUrl?: string;
    icon?: string;
}

/**
 * Audio event type to manipulate individual audio items
 */
export enum AudioItemEventType {
    MOVE = "MOVE",
    ENABLE = "ENABLE",
    DISABLE = "DISABLE",
    ROTATE = "ROTATE"
}

/**
 * Audio event to manipulate individual audio items
 */
export interface AudioItemEvent {
    target: AudioItemId,
    type: AudioItemEventType,
    position?: AudioItemPosition
}

/**
 * Audio source is a extention of the audio item, that holds
 * state of audio item playback state elements (for internal audio player usage)
 */
export interface AudioSource extends AudioItem {
    // Html audio 
    audioElement: HTMLAudioElement;
    // Used to connect / disconnect audio to context 
    sourceNode: AudioNode;
    // Resonance audio source used for positioning sound source 
    resonanceSource: any; // Resonance Source class (do not expose Resonance lib here)
}

export type AudioSourceMap = { [key: string]: AudioSource };
